module.exports = "/_next/static/images/c47562edc7aeb4fb1fcaa0c3a0e04f2c-notaxes@0.5x.jpg.webp";